import React from 'react';

import {Box, CircularProgress} from "@mui/material";

function TopTableLoader(props) {
    return (
        <Box sx={{display: "flex", justifyContent: "center", py: 6}}>
            <CircularProgress size={28}/>
        </Box>
    );
}

export default TopTableLoader;
